import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import MaintenanceFormModule from "../../../modules/maintenance/form";

const MaintenanceFormPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const { id } = useParams();
  const metaTitle = id
    ? t("pages.maintenance.detail.metaTitle")
    : t("pages.maintenance.add.metaTitle");

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/maintenance",
          title: t("common.text.maintenance"),
        },
        {
          link: `/maintenance/${id || "add"}`,
          title: id ? t("common.text.edit") : t("common.text.add"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t, id]);

  return (
    <>
      <VuiHelmet title={metaTitle} />

      <MaintenanceFormModule />
    </>
  );
};

export default MaintenanceFormPage;
